import React from 'react'

// Domains
import ImageDomain from '@src/quince-site-common/src/domains/Image'
import RichTextDomain from '@src/quince-site-common/src/domains/RichText'
import ContentfulProductMeasuringGuide from '@src/quince-site-common/src/domains/contentful/ContentfulMeasuringGuide'

// Components
import ImageC from '../../../image'
import { RichText as RichTextC } from '../../../../molecules'

// Styles
import styles from './measuringGuide.module.scss'
import classNames from 'classnames'
import POSITIONS from '@src/quince-site-common/src/constants/positions'
import LAYOUT_TYPES from '@src/quince-site-common/src/constants/layoutTypes'

interface MeasuringGuideProps {
  measuringGuide: ContentfulProductMeasuringGuide
}

const MeasuringGuide = (props: MeasuringGuideProps) => {
  const [measuringGuideContentRichTextPropsDesktop, measuringGuideContentRichTextMobile] = getContentRichTextProps(
    props.measuringGuide,
  )
  return (
    <div
      className={classNames(
        styles.measuringGuideWrapper,
        props.measuringGuide.position === POSITIONS.BOTTOM && styles.measuringGuideWrapper__bottomPosition,
      )}
    >
      <div className={classNames(styles.measuringGuideWrapper__measuringGuideContentWrapper, styles.desktopOnly)}>
        {measuringGuideContentRichTextPropsDesktop && <RichTextC {...measuringGuideContentRichTextPropsDesktop} />}
      </div>

      <div className={classNames(styles.measuringGuideWrapper__measuringGuideContentWrapper, styles.mobileOnly)}>
        {measuringGuideContentRichTextMobile && <RichTextC {...measuringGuideContentRichTextMobile} />}
      </div>

      {props.measuringGuide.images?.[0] && (
        <div
          className={classNames(
            styles.measuringGuideWrapper__measuringGuideImageWrapper,
            props.measuringGuide.layoutType === LAYOUT_TYPES.CENTER &&
              styles.measuringGuideWrapper__measuringGuideImageWrapper__centeredLayout,
          )}
        >
          <div className={styles.desktopOnly}>
            <ImageC
              {...ImageDomain.fromContentful(props.measuringGuide.images[0])}
              alt={props.measuringGuide.images[0]?.title || ''}
            />
          </div>

          <div className={styles.mobileOnly}>
            <ImageC
              {...ImageDomain.fromContentful(props.measuringGuide.images[1] || props.measuringGuide.images[0])}
              alt={props.measuringGuide.images[1]?.title || props.measuringGuide.images[0]?.title || ''}
            />
          </div>
        </div>
      )}
    </div>
  )
}

const getContentRichTextProps = (measuringGuide: ContentfulProductMeasuringGuide) => {
  const measuringGuideContentDesktop = measuringGuide.richTexts
    ? RichTextDomain.fromContentful(measuringGuide.richTexts[1])
    : undefined
  const measuringGuideContentRichTextPropsDesktop = RichTextDomain.makeRichTextProps(measuringGuideContentDesktop)

  const measuringGuideContentMobile = measuringGuide.richTexts
    ? RichTextDomain.fromContentful(measuringGuide.richTexts[3] || measuringGuide.richTexts[1])
    : undefined
  const measuringGuideContentRichTextPropsMobile = RichTextDomain.makeRichTextProps(measuringGuideContentMobile)

  return [measuringGuideContentRichTextPropsDesktop, measuringGuideContentRichTextPropsMobile]
}

export default MeasuringGuide
